import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import ScheduleVIISummaryPageUI from './ScheduleVIISummaryPageUI'

class ScheduleVIISummaryPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      account: null,
      accountSummary: null,
      loanDetails: null,
      yearMonth: '',
      loading: false,
    }
  }

  render() {
    return (
      <ScheduleVIISummaryPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        account={this.state.account}
        accountSummary={this.state.accountSummary}
        loanDetails={this.state.loanDetails}
        yearMonth={this.state.yearMonth}
        loading={this.state.loading}
        onYearMonthChange={this.onYearMonthChange}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    const context = this.props.context
    this.getAccount(context)
    this.getSchedule7Compliance(context, this.state.yearMonth)
  }

  getAccount(context) {
    const accountId = this.props.match.params.accountId
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}`,
      cacheKey: CacheKeys.Account(accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountCallback = (response) => {
    this.setState({ account: response.account })
  }

  getSchedule7Compliance(context, yearMonth) {
    this.setState({ loading: true, accountSummary: null, loanDetails: null, errorList: null })

    const accountId = this.props.match.params.accountId
    const ymParam = yearMonth && yearMonth.trim() !== '' ? yearMonth.trim() : ''
    const resource = `/api/su/accounts/${accountId}/schedule7/compliance${ymParam ? '?yearMonth=' + ymParam : ''}`

    let cacheManager = new CacheManager({
      resource: resource,
      cacheKey: 'schedule7_' + accountId + '_' + (ymParam || 'current'),
      callback: this.getSchedule7ComplianceCallback,
      ttlInSecs: 0
    })
    cacheManager.getObject2(context)
  }

  getSchedule7ComplianceCallback = (response) => {
    this.setState({
      loading: false,
      errorList: response.errorList,
      accountSummary: response.accountSummary,
      loanDetails: response.loanDetails,
    })
  }

  onYearMonthChange = (yearMonth) => {
    this.setState({ yearMonth }, () => {
      this.getSchedule7Compliance(this.props.context, yearMonth)
    })
  }

  onRefreshClick = () => {
    const accountId = this.props.match.params.accountId
    const ymParam = this.state.yearMonth && this.state.yearMonth.trim() !== '' ? this.state.yearMonth.trim() : ''
    CacheManager.removeObject(CacheKeys.Account(accountId))
    CacheManager.removeObject('schedule7_' + accountId + '_' + (ymParam || 'current'))

    this.setState(
      { account: null, accountSummary: null, loanDetails: null, errorList: null },
      () => {
        const context = this.props.context
        this.getAccount(context)
        this.getSchedule7Compliance(context, this.state.yearMonth)
      }
    )
  }
}

export default withRouter(ScheduleVIISummaryPageSF)